import { publishAuthLogoutToTabs } from './composables/useAuthIdentityTabSync';

interface Auth0LogoutOptions {
  domain: string;
  clientId: string;
  returnTo: string;
}

export const getAuth0LogoutUrl = ({ domain, clientId, returnTo }: Auth0LogoutOptions) => {
  const auth0Origin =
    domain.startsWith('http://') || domain.startsWith('https://') ? domain : `https://${domain}`;
  const logoutUrl = new URL('/v2/logout', auth0Origin);

  logoutUrl.searchParams.set('client_id', clientId);
  logoutUrl.searchParams.set('returnTo', returnTo);

  return logoutUrl.toString();
};

export const redirectToAuth0Logout = (options: Auth0LogoutOptions) => {
  publishAuthLogoutToTabs();
  window.location.assign(getAuth0LogoutUrl(options));
};
